import JSGroupsIntro from "../../../../contents/docs/_snippets/groups-intro.mdx";
import JSGroupsVSCohorts from "../../../../contents/docs/_snippets/groups-vs-cohorts.mdx";
import JSCreateGroups from "../../../../contents/docs/_snippets/how-to-create-groups.mdx";
import JSSetGroupProperties from "../../../../contents/docs/_snippets/setting-group-properties.mdx";
import JSLinkEventsToGroups from "../../../../contents/docs/_snippets/how-to-link-events-to-groups.mdx";
import JSGroupsUseCases from "../../../../contents/docs/_snippets/groups-use-cases.mdx";
import * as React from 'react';
export default {
  JSGroupsIntro,
  JSGroupsVSCohorts,
  JSCreateGroups,
  JSSetGroupProperties,
  JSLinkEventsToGroups,
  JSGroupsUseCases,
  React
};